module.exports = __webpack_public_path__ + "static/media/4-5-v-nebi-korunoval.21a23915.jpg";